export { userListScreen, userDetailScreen } from './user.screen';
export { userListSearch, userDetailSearch } from './user.search';
export { loadUserMessages } from './user.catalog';
export const loadUserScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadUserGuides = () => import('./user.guide');
